// @flow

import React from 'react'
import type { Node } from 'react'
import styled from 'styled-components'

import { myTheme, themedTextColor } from '../../styles'

const { fontWeight } = myTheme

const StyledBlockQuote = styled.blockquote`
  border-left: 0.125rem solid ${themedTextColor};
  font-weight: ${fontWeight.five};
  margin-left: 0;
  margin-right: 0;
`

type Props = {
  children: Node,
}

const BlockQuote = ({ children }: Props) => (
  <StyledBlockQuote className="py2 pl3 sm-pl4 relative">
    {children}
  </StyledBlockQuote>
)

export default BlockQuote



// WEBPACK FOOTER //
// ./src/components/typography/blockquote.js